import type {MigrationInterface, QueryRunner} from "typeorm";

export class AddSubscriptionColumn1737711384844 implements MigrationInterface {
  name = "AddSubscriptionColumn1737711384844";

  async up(queryRunner: QueryRunner): Promise<void> {
    // Add the subscription column to the user table
    await queryRunner.query(`ALTER TABLE "user" ADD COLUMN "subscription" text`);
  }

  async down(queryRunner: QueryRunner): Promise<void> {
    // Remove the subscription column from the user table
    await queryRunner.query(`ALTER TABLE "user" DROP COLUMN "subscription"`);
  }
}
